// © Microsoft Corporation. All rights reserved.

/**
 * Default key value for looking up experience instances
 */
export const defaultInstanceKeyName: string = "default";

/**
 * Default time value for start/end time
 */
export const defaultTimeValue: number = -1;
